// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/companies/{OrgId}/titles",
  Detail: "/pyr/companies/{OrgId}/titles",
  ListShort: "/pyr/companies/{OrgId}/titles/short",
  Create: "/pyr/companies/{OrgId}/titles",
  Update: "/pyr/companies/{OrgId}/titles",
};
